import Select, { OptionProps } from '@storeblocks/select';
import { Field, FieldProps } from 'formik';
import { FunctionComponent } from 'react';

interface Props {
  name: string;
  label: string;
  hint?: string;
  options: OptionProps[];
  error?: string;
  defaultOptionLabel?: string;
  fluid?: boolean;
}

export const FormSelect: FunctionComponent<Props> = ({
  name,
  label,
  hint,
  options,
  error = '',
  ...rest
}): JSX.Element => (
  <Field name={name}>
    {({ field, form }: FieldProps) => (
      <Select
        {...field}
        id={name}
        label={label}
        hint={hint}
        options={options}
        onChange={(event) => form.setFieldValue(name, event.target.value)}
        alertMessage={error}
        alertMessageType={error ? 'error' : undefined}
        value={field.value}
        {...rest}
      />
    )}
  </Field>
);
